import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./services.css";

import ChillerTruck from "../../assets/images/FreezerVan/chiller-truck-service.webp";
import ChillerVan from "../../assets/images/ChillerVan/chiller-van-service.jpeg";
import FreezerVan from "../../assets/images/FreezerVan/freezer-van-service.webp";
import HighRoofVan from "../../assets/images/Home/high-roof-van-service-chiller-dubai-sharjah-rent-freeze.webp";
import FreezerTruck from "../../assets/images/Home/freezer-truck-service-chiller-van.webp";
import RefrigeratedTruck from "../../assets/images/Home/refrigerated-truck-service-chiller-freeze.webp";

import SeatIcon from "../../assets/images/icons/seat.png";
import DoorIcon from "../../assets/images/icons/doors.png";
import EngineIcon from "../../assets/images/icons/engine.png";


const services = [
  {
    id: "chiller-truck",
    name: "Chiller Truck",
    link: "/chiller-truck-for-rent",
    img: ChillerTruck,
    description:
      "Our chiller trucks ensure safe transport of perishable goods, healthcare products, and temperature-sensitive cargo across Dubai.",
    seats: "2 Seats",
    doors: "2 Doors",
    engine: "2.5L Diesel",
    gear: "Manual Gear",
  },
  {
    id: "chiller-van",
    name: "Chiller Van",
    link: "/chiller-van-for-rent",
    img: ChillerVan,
    description:
      "Reliable chiller van rentals for pharma, food, and perishable deliveries with complete temperature control.",
    seats: "2 Seats",
    doors: "4 Doors",
    engine: "2.0L Diesel",
    gear: "Manual Gear",
  },
  {
    id: "freezer-truck",
    name: "Freezer Truck",
    link: "/freezer-truck-for-rent",
    img: FreezerTruck,
    description:
      "Temperature-controlled freezer truck rentals for frozen food and long-distance cold chain logistics.",
    seats: "3 Seats",
    doors: "2 Doors",
    engine: "3.0L Diesel",
    gear: "Manual Gear",
  },
  {
    id: "freezer-van",
    name: "Freezer Van",
    link: "/freezer-van-for-rent",
    img: FreezerVan,
    description:
      "Advanced freezer vans maintaining optimal frozen conditions throughout transport.",
    seats: "2 Seats",
    doors: "4 Doors",
    engine: "2.2L Diesel",
    gear: "Automatic Gear",
  },
  {
    id: "high-roof",
    name: "High Roof Van",
    link: "/high-roof-dry-van-for-rent",
    img: HighRoofVan,
    description:
      "High roof vans with extra cargo height for oversized goods transport.",
    seats: "3 Seats",
    doors: "4 Doors",
    engine: "2.4L Diesel",
    gear: "Manual Gear",
  },
  {
    id: "refrigerated-truck",
    name: "Refrigerated Truck",
    link: "/refrigerated-trucks-for-rent",
    img: RefrigeratedTruck,
    description:
      "Reliable refrigerated truck rentals for cold storage transport solutions in Dubai.",
    seats: "3 Seats",
    doors: "2 Doors",
    engine: "2.8L Diesel",
    gear: "Manual Gear",
  },
];

const ServicesAllVans = () => {
  const [activeService, setActiveService] = useState(services[0]);

  return (
    <section className="fleet-section py-5">
      <div className="container">

        {/* SEO Optimized H1 */}
        <h1 className="text-center mb-3" data-aos="fade-up" data-aos-delay="300">
          Chiller & Freezer Van Rental Services in Dubai
        </h1>

        <p className="text-center fleet-subtitle mb-4" data-aos="fade-up" data-aos-delay="400">
          Affordable temperature-controlled vans and trucks for food, pharma and cold chain logistics.
        </p>

        {/* Tabs */}
        <div className="fleet-tabs mb-4" data-aos="fade-up" data-aos-delay="500">
          {services.map((service) => (
            <button
              key={service.id}
              onClick={() => setActiveService(service)}
              className={`fleet-tab ${
                activeService.id === service.id ? "active" : ""
              }`}
            >
              {service.name}
            </button>
          ))}
        </div>

        {/* Card */}
        <div className="row fleet-card align-items-center">

          <div className="col-lg-5 mb-3 mb-lg-0" data-aos="fade-left" data-aos-delay="300">
            <img
              src={activeService.img}
              alt={activeService.name}
              className="img-fluid fleet-img"
              loading="lazy"
            />
          </div>

          <div className="col-lg-7"data-aos="fade-right" data-aos-delay="400">
            <div className="fleet-details">
              <h2><Link to={activeService.link} className="internal-link">{activeService.name}</Link></h2>
              <p>{activeService.description}</p>

              {/* Specifications */}
              <div className="row specs-row">

                <div className="col-6 col-md-3 spec-box">
                  <img src={SeatIcon} alt="Seat Icon" />
                  <span>{activeService.seats}</span>
                </div>

                <div className="col-6 col-md-3 spec-box">
                  <img src={DoorIcon} alt="Door Icon" />
                  <span>{activeService.doors}</span>
                </div>

                <div className="col-6 col-md-3 spec-box">
                  <img src={EngineIcon} alt="Engine Icon" />
                  <span>{activeService.engine}</span>
                </div>

                <div className="col-6 col-md-3 spec-box">
             
                  <span>{activeService.gear}</span>
                </div>

              </div>

              <div className="mt-4">

               <a href="https://wa.me/971544792905?text=Hi%20I%20want%20to%20book%20a%20service"
  target="_blank"
  rel="noopener noreferrer"
  className="fleet-btn me-3"
>
  Book Now
</a>
                <a href="tel:+971544792905" className="fleet-btn-outline">
                  Call Now
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ServicesAllVans;